import React, { useEffect, useRef, useState } from 'react'
import iconSearch from "../../../../assets/Icons/search_icon.svg";
import { SitesExpandable } from "../SitesExpandable/SitesExpandable";

import './SiteModalContent.css'
import { useDispatch, useSelector } from 'react-redux';
import { getSites, createSite } from '../../services/locationsConfigurationService';
import { environment } from '../../../../environments/environment';
import { setSites } from '../../../../redux/features/configuration/locations/locationsSitesSlice';
import { localStorageGet, localStorageSave } from '../../../../services/localStorageService';
import { HTTP_RESPONSE_CODES } from '../../../../globals/globals';
import { ResultsNotFound } from '../../../../components/ResultsNotFound/ResultsNotFound';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { Sorting } from '../../../../components/Lists/Sorting';


export const SiteModalContent = ({ closeModal, locationId, locationName, locationTimeZone }) => {
    const siteDraftPrefix = "configuration/locationConfiguration/draft/sites/"
    const [sites, setSites] = useState([])
    const { warningMsg, successMsg } = useSnackBar();
    const [draftSites, setDraftSites] = useState([])
    const [mostRecentSite, setMostRecentSite] = useState(null);
    const [allSites, setAllSites] = useState([]);
    const [totalSites, setTotalSites] = useState(0)
    const debounceRef = useRef(null)
    let page = 0;
    let maxPages = 0;
    const [pageSize, setPageSize] = useState(environment.ElemensPerPage)
    const sitesSectionRef = useRef(null)
    const [searchValue, setSearchValue] = useState("")
    const [sortingOrder, setSortingOrder] = useState("name");

    // functions

    const handleScroll = () => {
        const section = sitesSectionRef.current;
        if (section) {
            const { scrollTop, scrollHeight, clientHeight } = section;
            if (scrollTop + clientHeight >= scrollHeight - 2) {
                getMoreSites()
            }

        }
    };

    const getMoreSites = () => {
        if (page >= maxPages) {
            return;
        }
        let body = [
            { columnName: "locationId", value: locationId },
            {
                columnName: "accountId",
                value: [parseInt(localStorage.getItem("u_account_id"))],
            },
        ]
        getAllSites(page, pageSize
            , true, body
        )
    }

    const getAllSites = async (pageParameter, pageSizeParameter, isScroll, body, isSearch = false, order = sortingOrder) => {
        let draftSites = localStorageGet(siteDraftPrefix, { locationId: locationId });

        try {
            if (isScroll) {
                const request = await getSites(page, pageSize, body, order);
                if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
                    setSites((prevSites) => {
                        return [...prevSites, ...request.data.load];
                    });
                    setDraftSites(draftSites);
                    maxPages = request.data.totalPages;
                    page += 1;
                }
            } else {
                const request = await getSites(pageParameter, pageSizeParameter, body, order);
                if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {

                    const combinedSites = request.data.load.map(site => {
                        const draftSite = draftSites.find(draft => draft.id === site.id);
                        return draftSite ? { ...site, ...draftSite } : site;
                    });

                    setSites(combinedSites);

                    if (isSearch) {
                        if (body.length > 1 && body[1].value) {
                            const searchValue = body[1].value.toLowerCase();
                            draftSites = draftSites.filter((site) =>
                                site.name ? site.name.toLowerCase().includes(searchValue) : false
                            );
                        }

                    }
                    setDraftSites(draftSites);
                    setTotalSites(request.data.totalRecords);

                    page = 1;
                    maxPages = request.data.totalPages;
                    return request.data.load;
                }
            }
        } catch (error) {
            console.error("Something went wrong trying to get more sites: ", error);
        }
    };

    const creatNewSite = async () => {
        const request = await createSite()
        if (request.data.responseCode == HTTP_RESPONSE_CODES.CREATED) {
            localStorageSave(siteDraftPrefix, {locationId: locationId, siteId: request.data.load.id }, request.data.load)

            setMostRecentSite(request.data.load.id)
            let body = [
                { columnName: "locationId", value: locationId },
                {
                    columnName: "accountId",
                    value: [parseInt(localStorage.getItem("u_account_id"))],
                },
            ]
            successMsg("Site Created", "Site Created Successfully")
            getAllSites(0, pageSize, false, body)
        }
    }

    const combineSites = () => {
        const uniqueDraftSites = draftSites?.length > 0
            ? draftSites.filter(draftLocation =>
                !sites.some(site => site.id === draftLocation.id)
            )
            : [];

        setAllSites([...uniqueDraftSites, ...sites]);
    };


    const handleSearchOfLocation = (e) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            let body = [
                { columnName: "locationId", value: locationId },
                { columnName: "name", "value": e },
                {
                    columnName: "accountId",
                    value: [parseInt(localStorage.getItem("u_account_id"))],
                },
            ]

            getAllSites(0, pageSize, false, body, true)
        }, environment.debounceTime);
    }

    useEffect(() => {
        handleSearchOfLocation(searchValue)
    }, [searchValue])

    useEffect(() => {
        let body = [
            { columnName: "locationId", value: locationId },
            {
                columnName: "accountId",
                value: [parseInt(localStorage.getItem("u_account_id"))],
            },
        ]
        getAllSites(0, pageSize, false, body)
        setMostRecentSite(null)
        const section = sitesSectionRef.current;
        if (section) {
            section.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (section) {
                section.removeEventListener('scroll', handleScroll);
            }
        };
    }, [])

    useEffect(() => {
        let body = [
            { columnName: "locationId", value: locationId },
            {
                columnName: "accountId",
                value: [parseInt(localStorage.getItem("u_account_id"))],
            },
        ]

        getAllSites(0, pageSize, false, body)

    }, [sortingOrder])

    useEffect(() => {
        combineSites()
    }, [sites, draftSites])


    const reloadSites = (id) => {
        let body = [
            { columnName: "locationId", value: locationId },
            {
                columnName: "accountId",
                value: [parseInt(localStorage.getItem("u_account_id"))],
            },
        ]
        setDraftSites(prevSites => prevSites.filter(site => site.id !== id));
        getAllSites(0, pageSize, false, body)
        setMostRecentSite(null)

    }

    const getSortingChange = (data) => {
        setSortingOrder(data)
    }

    return (
        <section className="sites-config-modal-cont">
            <header>
                <p>{locationName ? locationName : "--"}<span>{locationTimeZone ? locationTimeZone : "--"}</span></p>
                <i onClick={closeModal} className="icon-cross" style={{ cursor: "pointer" }} ></i>
            </header>
            <div className="sites-config-modal-searchCont">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="20.582"
                    height="21.386"
                    viewBox="0 0 20.582 21.386"
                    className="custom-svg"
                >
                    <defs>
                        <clipPath id="clip-path">
                            <rect
                                id="Rectangle_1399"
                                data-name="Rectangle 1399"
                                width="20.582"
                                height="21.386"
                            />
                        </clipPath>
                    </defs>
                    <g
                        id="Group_2653"
                        data-name="Group 2653"
                        clipPath="url(#clip-path)"
                    >
                        <path
                            id="Path_1250"
                            data-name="Path 1250"
                            d="M78.081,79.9a2.271,2.271,0,1,0-2.271-2.271A2.273,2.273,0,0,0,78.081,79.9m0-2.954a.683.683,0,1,1-.683.683.684.684,0,0,1,.683-.683"
                            transform="translate(-72.644 -72.212)"
                        />
                        <path
                            id="Path_1251"
                            data-name="Path 1251"
                            d="M20.217,7.153a5.652,5.652,0,0,0-4.389-4.389h-.008A28.855,28.855,0,0,0,11.087,2.4c-.383,0-.761.007-1.13.019A5.429,5.429,0,0,0,5.442,0h-.01A5.438,5.438,0,0,0,0,5.432,7.621,7.621,0,0,0,1.662,9.775c-.044.677-.066,1.387-.067,2.118a28.826,28.826,0,0,0,.364,4.73v.008A5.652,5.652,0,0,0,6.35,21.02h.008a28.855,28.855,0,0,0,4.732.364,28.84,28.84,0,0,0,4.73-.364h.008a5.652,5.652,0,0,0,4.389-4.389v-.008a28.847,28.847,0,0,0,.364-4.732,28.847,28.847,0,0,0-.364-4.73V7.153ZM5.432,1.587h.01A3.849,3.849,0,0,1,9.287,5.432,6.236,6.236,0,0,1,7.777,9.043,8.19,8.19,0,0,1,5.44,11.171a8.143,8.143,0,0,1-2.3-2.079.787.787,0,0,0-.078-.1,6.182,6.182,0,0,1-1.472-3.56A3.849,3.849,0,0,1,5.432,1.587ZM3.186,11.469a6.831,6.831,0,0,0,1.743,1.216,1.282,1.282,0,0,0,1.02,0,9.236,9.236,0,0,0,3.08-2.667,7.524,7.524,0,0,0,1.844-4.586,5.417,5.417,0,0,0-.2-1.444l.409,0a27.232,27.232,0,0,1,4.467.342,3.6,3.6,0,0,1,1.4.6L4.12,17.757a3.6,3.6,0,0,1-.6-1.4,27.246,27.246,0,0,1-.342-4.465c0-.142,0-.283,0-.424Zm12.369,7.987a27.222,27.222,0,0,1-4.465.342,27.232,27.232,0,0,1-4.467-.342,3.593,3.593,0,0,1-1.377-.58l5.845-5.845,5.844,5.844a3.59,3.59,0,0,1-1.38.582Zm3.1-3.1a3.6,3.6,0,0,1-.594,1.4l-5.846-5.846,5.86-5.86a3.591,3.591,0,0,1,.58,1.377A27.225,27.225,0,0,1,19,11.891a27.221,27.221,0,0,1-.342,4.467Z"
                            transform="translate(0 0)"
                        />
                    </g>
                </svg>
                <span>{totalSites}</span>
                <p>Sites</p>

                <div className='sites-search-cont'>
                    <input onChange={(event) => setSearchValue(event.target.value)} type="text" placeholder="Search" value={searchValue} />
                    {
                        searchValue == "" || searchValue == null ? <i className="icon-search"></i> : <i style={{
                            fontSize: "calc(var(--p-size) + .1rem)",
                            cursor: "pointer"
                        }} className="icon-cross"
                            onClick={() => {
                                setSearchValue("")
                            }}
                        ></i>
                    }
                </div>
                <button onClick={creatNewSite} className='btn-add-new-site'><i className='icon-add-new'> </i>New Site</button>
                <div>
                    <p>
                        <span style={{
                            background: "#29ABE2"
                        }}></span> Sites
                    </p>
                    <p>
                        <span style={{
                            background: "#50D999"
                        }}></span>
                        Racks
                    </p>
                    <p>
                        <span style={{
                            background: "#E29E29"
                        }}></span>
                        Shelves
                    </p>
                    <p>
                        <span style={{
                            background: "#BD68F6"
                        }}></span>
                        Bins
                    </p>
                    <p></p>
                </div>
            </div>
            <section className="sites-config-modal-sitesCont" ref={sitesSectionRef}>
                <Sorting
                    showHeaderOrder={true}
                    onOrderChange={getSortingChange}
                    properties={{
                        name: "Name",
                        Code: "Code",
                        Type: "Type",


                    }}
                    displayButton={false}
                />
                {
                    allSites.length > 0 ? allSites.map((site) => {
                        return (
                            <SitesExpandable
                                siteBasicInfo={site}
                                isDraft={draftSites.some((e) => e.id === site.id)}
                                isNewSite={mostRecentSite === site.id}
                                key={site.id}
                                location_id={locationId}
                                reload={reloadSites}
                                informationOfDraft={draftSites.find((e) => e.id === site.id)}
                                listLenght={allSites.length}
                            />
                        );
                    }) : <div style={{
                        height: "15rem",
                        width: "100%",

                    }}>
                        <ResultsNotFound></ResultsNotFound>
                    </div>
                }
            </section>
        </section>
    )
}
